import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { useMerchant } from 'hooks/useGlobalContext/useMerchant'
import { useMessageStore } from 'hooks/useGlobalContext/useMessageStore'

export const walletPassWarningContent = (
  <>
    To enable wallet passes, please make sure your loyalty is set to Staff Scans
    Loyalty{' '}
    <Link to='/loyalty/settings' style={{ textDecoration: 'underline' }}>
      here
    </Link>
  </>
)

const WALLET_PASS_PATH = '/designer/wallet-pass'

const useWalletPassAlert = () => {
  const { merchantData } = useMerchant()
  const { addMessage, removeMessage, messages } = useMessageStore()
  const messageIdRef = useRef<string | null>(null)
  const location = useLocation()

  const onWalletPassPage = location.pathname === WALLET_PASS_PATH
  const walletPassNeedsWarning =
    merchantData?.add_to_wallet_enabled === true &&
    merchantData?.loyalty_scan_method === 'customer'

  useEffect(() => {
    if (!walletPassNeedsWarning) {
      if (messageIdRef.current) {
        removeMessage(messageIdRef.current)
        messageIdRef.current = null
      }
      const strayMsg = messages.find(
        (m) => m.content === walletPassWarningContent
      )
      if (strayMsg) removeMessage(strayMsg.id)
      return
    }

    // Only add the warning from the wallet pass designer page
    if (!onWalletPassPage) return
    if (messageIdRef.current) return

    messageIdRef.current = addMessage({
      type: 'cta',
      content: walletPassWarningContent,
      dismissable: true
    })
  }, [
    onWalletPassPage,
    walletPassNeedsWarning,
    addMessage,
    removeMessage,
    messages
  ])
}

export default useWalletPassAlert
